module.exports = __webpack_public_path__ + "static/media/iconfont.f2c0d581.eot";